import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { IoInformationCircleOutline } from "react-icons/io5";
import VuiBox from "components/ui/VuiBox";
import VuiTypography from "components/ui/VuiTypography";

// For tables
function TooltipHeader({ label, tooltip, align = "center" }) {
  return (
    <VuiBox display="flex" alignItems="center" justifyContent="center">
      <VuiBox
        textAlign="center"
        color="#fff"
        sx={{ fontWeight: 600 }}
      >
        {label}
      </VuiBox>
      <Tooltip
        title={
          <VuiTypography
            variant="button"
            color="white"
            fontWeight="regular"
            sx={{
              fontSize: "11px",
              lineHeight: 1.4,
              fontFamily: "Sora, sans-serif",
            }}
          >
            {tooltip}
          </VuiTypography>
        }
        placement="top"
        arrow
      >
        <div style={{ display: "inline-block", cursor: "pointer", marginLeft: "4px" }}>
          <IoInformationCircleOutline size="14px" color="white" />
        </div>
      </Tooltip>
    </VuiBox>
  );
}

export default TooltipHeader;